import React from 'react';
import logo from '../assests/Cardinal.png';
import '../static/css/app.css';
class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div id="footer" className="container-fluid">

                <div id="footer-detail">
                    <img src={logo} alt="Logo" id="flogo" height="60" width="60" />
                    <small>&copy; Copyright 2022, Deepak Kumar</small>
                    <div style={{ float: "right" }}>
                        <a href=""></a> <br></br>
                        <a href=""></a> <br></br>
                        <a href=""></a> <br></br>
                        <a href=""></a>
                        
                    </div>

                </div>


            </div>


        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js